import { style } from "typestyle";

export const donutWrapperClassName = style({
    $debugName: 'donut.component',

    display: 'block',
    position: 'relative'
});

export const donutOverlayClassName = style({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    pointerEvents: 'none',
    width: '100%',
    height: '100%',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
});

export const donutOverlayContentClassName = style({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignItems: 'center',
    pointerEvents: 'none',
    background: 'transparent',
    overflow: 'visible',
    borderRadius: '50%'
});

export const donutOverlayContent75ClassName = style({
    width: '75%',
    height: '75%'
});

export const donutOverlayContent65ClassName = style({
    width: '65%',
    height: '65%'
});
